export default "__VITE_ASSET__7d8aaf1d__"